import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { Box, Theme, Typography, createStyles, makeStyles } from '@material-ui/core';
import { CommissionPlan } from '@spike/commission-model';
import { ActionText } from 'components/UI/ActionableTexts/ActionText';
import State from 'components/UI/Chips/State';
import { memo } from 'react';

interface CommissionItemProps {
    className?: string;
    commissionPlan: CommissionPlan;
    active: boolean;
    isLast?: boolean;
    onView?: (_uuid: string, _active: boolean) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        commissionListItemContainer: {
            width: '100% !important',
            display: 'flex',
            alignItems: 'center',
            paddingTop: (props: CommissionItemProps) => (props.active === true ? '0px' : '20px'),
            paddingBottom: '20px',
            marginTop: '5px',
            borderBottom: (props: CommissionItemProps) =>
                props.isLast === true ? '0px #D4D4D4 solid' : '1px #D4D4D4 solid'
        },
        comissionListItemChipContainer: {
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'flex-start',
            width: 120
        },
        commisionListItemActionTextContainer: {
            flexShrink: 0,
            marginLeft: 16
        },
        commisionListItemDescContainer: {
            flex: 1
        },
        commissionListItemDescText: {
            fontWeight: 500,
            [theme.breakpoints.down('sm')]: {
                fontSize: 13
            }
        },
        commissionListItemChip: {}
    })
);

function CommissionItemBase({ commissionPlan, active, isLast, onView }: CommissionItemProps) {
    const classes = useStyles({ commissionPlan, active, isLast });

    return (
        <Box className={classes.commissionListItemContainer}>
            <Box className={classes.commisionListItemDescContainer}>
                <Typography className={classes.commissionListItemDescText}>
                    From {commissionPlan.from.format('MMM DD, YYYY')}{' '}
                    {active && 'at ' + commissionPlan.from.format('hh:mm a')}
                </Typography>
            </Box>
            <Box className={classes.comissionListItemChipContainer}>
                {' '}
                <State
                    className={classes.commissionListItemChip}
                    state={active ? { id: 'SUCCESS', name: 'Active' } : { id: 'DISABLED', name: 'Deactivated' }}
                ></State>{' '}
            </Box>
            <Box className={classes.commisionListItemActionTextContainer}>
                {' '}
                <ActionText
                    icon={faEye}
                    label={'View'}
                    onClick={() => onView && onView(commissionPlan.uuid, active)}
                ></ActionText>
            </Box>
        </Box>
    );
}

export const CommissionItem = memo(CommissionItemBase);
